import { View, Text, ScrollView, TouchableOpacity, TextInput, ActivityIndicator, StyleSheet } from 'react-native';
import type { Exercise, DuelType } from './types';
import { CATEGORIES } from './types';

interface Props {
  colors: Record<string, string>;
  duelType: DuelType | null;
  exercises: Exercise[];
  filteredExercises: Exercise[];
  selectedExercise: Exercise | null;
  selectedCategory: string | null;
  searchQuery: string;
  loadingExercises: boolean;
  onSearchChange: (q: string) => void;
  onSelectExercise: (ex: Exercise) => void;
  onSelectCategory: (id: string) => void;
  onBack: () => void;
}

export default function DetailsStep({
  colors: c, duelType, filteredExercises, selectedExercise,
  selectedCategory, searchQuery, loadingExercises,
  onSearchChange, onSelectExercise, onSelectCategory, onBack,
}: Props) {
  return (
    <View style={styles.stepContent}>
      <Text style={[styles.stepTitle, { color: c.text }]}>
        {(duelType === 'pr' || duelType === '1rm' || duelType === 'strength') ? 'Select Exercise' : 'Select Category'}
      </Text>

      {(duelType === 'pr' || duelType === '1rm' || duelType === 'strength') ? (
        <>
          <TextInput
            style={[
              styles.searchInput,
              { backgroundColor: c.surfaceVariant, color: c.text, borderColor: c.border },
            ]}
            placeholder="Search exercises..."
            placeholderTextColor={c.textTertiary}
            value={searchQuery}
            onChangeText={onSearchChange}
          />

          {loadingExercises ? (
            <ActivityIndicator size="large" color={c.accent} />
          ) : (
            <ScrollView style={styles.exerciseList}>
              {filteredExercises.map((exercise) => (
                <TouchableOpacity
                  key={exercise.id}
                  style={[
                    styles.exerciseItem,
                    {
                      backgroundColor:
                        selectedExercise?.id === exercise.id ? c.accent + '20' : c.surface,
                      borderColor: c.border,
                    },
                  ]}
                  onPress={() => onSelectExercise(exercise)}>
                  <Text style={[styles.exerciseName, { color: c.text }]}>{exercise.name}</Text>
                  <Text style={[styles.exerciseCategory, { color: c.textSecondary }]}>
                    {exercise.category}
                  </Text>
                </TouchableOpacity>
              ))}
            </ScrollView>
          )}
        </>
      ) : (
        <ScrollView style={styles.categoryList}>
          {CATEGORIES.map((cat) => (
            <TouchableOpacity
              key={cat.id}
              style={[
                styles.categoryItem,
                {
                  backgroundColor: selectedCategory === cat.id ? c.accent + '20' : c.surface,
                  borderColor: c.border,
                },
              ]}
              onPress={() => onSelectCategory(cat.id)}>
              <Text style={[styles.categoryName, { color: c.text }]}>{cat.name}</Text>
            </TouchableOpacity>
          ))}
        </ScrollView>
      )}

      <TouchableOpacity
        style={[styles.backButton, { backgroundColor: c.surfaceVariant }]}
        onPress={onBack}>
        <Text style={[styles.backButtonText, { color: c.text }]}>Back</Text>
      </TouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  stepContent: { flex: 1, padding: 20 },
  stepTitle: { fontSize: 20, fontWeight: '800', marginBottom: 16 },
  searchInput: {
    borderWidth: 1, borderRadius: 2, padding: 12, fontSize: 15, marginBottom: 12,
  },
  exerciseList: { flex: 1 },
  exerciseItem: {
    borderWidth: 1, borderRadius: 2, padding: 12, marginBottom: 8,
  },
  exerciseName: { fontSize: 15, fontWeight: '600' },
  exerciseCategory: { fontSize: 12, marginTop: 2 },
  categoryList: { flex: 1 },
  categoryItem: {
    borderWidth: 1, borderRadius: 2, padding: 14, marginBottom: 8,
  },
  categoryName: { fontSize: 15, fontWeight: '600' },
  backButton: { padding: 14, borderRadius: 0, alignItems: 'center', marginTop: 8 },
  backButtonText: { fontSize: 15, fontWeight: '600' },
});
